module.exports = __webpack_public_path__ + "assets/small-logo.840f08ba.svg";